<template>
  <div class="PaB-quantity">
    <button @click="decrement">-</button>
    <input type="number" :min="min" :max="max" v-model="value" @change="updateValue">
    <button @click="increment">+</button>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: Infinity
    }
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  methods: {
    increment () {
      if (this.value < this.max) {
        this.$emit('input', +this.value + 1)
      }
    },
    updateValue () {
      this.$emit('input', +this.value)
    },
    decrement () {
      if (this.value > this.min) {
        this.$emit('input', +this.value - 1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.PaB-quantity {
  display: flex;

  button {
    display: block;
    font-size: 30px;
    font-weight: 100;
    line-height: 30px;
    width: 44px;
    min-height: 44px;
    height: 100%;
    flex: 0 0 44px;
    padding: 0;
    -webkit-appearance: none;
    &:first-child {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    &:last-child {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
  button,
  input {
    background-color: #fff;
    border: 1px solid #b2b2b2;
    margin: 0;
    -webkit-appearance: none;
  }
  input {
    width: auto;
    border-left: 0;
    border-right: 0;
    box-shadow: none;
    border-radius: 0;
    flex: 1;
    min-width: 0;
    max-width: none;
    text-align: center;
    min-height: 44px;
    height: 100%;
    padding: 0 5px;
    font-size: inherit;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}
</style>
